<header>
  <nav class="navbar navbar-expand-lg background">

    <!--<p class="navbar-brand">
      <a href="#"><img src="../assets/Images/logo.png"></a>
    </p>-->

  <p class="navbar-brand">
  <img *ngIf="data" class="logo-white" src="assets/Images/logo.png" (click)="Back()"/>
  <a href="#"><img *ngIf="!data" class="logo-white" src="assets/Images/logo.png" /></a>
</p>


    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav"
            aria-expanded="false" aria-label="Toggle navigation">
      <i class="fa fa-bars"></i>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav" style=" font-size: small; ">

        <li [routerLink]="['/AboutUs']">
          <img class="mr-4 nav-icons" src="assets/Images/about-us.svg" /><span style="cursor: pointer">About Us</span>
        </li>
        <li [routerLink]="['/Contactus']">
          <img class="mr-4 nav-icons" src="assets/Images/phone.svg" /><span style="cursor: pointer">Contact Us</span>
        </li>
      </ul>
      <ul class="navbar-nav ml-auto" *ngIf="!data" [hidden]="data">
        <li>
          <label style="cursor: pointer; text-decoration: underline;" (click)="openModal()">Login</label>
        </li>
        <li>
          <label style="cursor: pointer; text-decoration: underline;" (click)="openModal1()">Sign Up</label>
        </li>
      </ul>

      <ul class="navbar-nav ml-auto" [hidden]="!data">
        <!--<li *ngIf="data && token" (click)="Notificationweb()">
          <div class="containernotifi">
            <i class="icon1 fa fa-bell-o">
              <label class="badge">{{notificationdataList}}</label>
            </i>
          </div>
        </li>-->
        <li *ngIf="data && token">
          <a [routerLink]="['/PromoList']" class="btn btn-warning" style="float:right; cursor: pointer !important;">
            Your Free Promo Code
          </a>
        </li>

        <li *ngIf="data && token">
          <a [routerLink]="['/Orderdetail']">

            <div class="add-balance" style="cursor: pointer !important;">
              <svg xmlns="http://www.w3.org/2000/svg" width="2.55em" height="2em" viewBox="0 -250 1792 1765"><path fill="currentColor" d="M384 1056v64q0 13-9.5 22.5T352 1152h-64q-13 0-22.5-9.5T256 1120v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5m0-256v64q0 13-9.5 22.5T352 896h-64q-13 0-22.5-9.5T256 864v-64q0-13 9.5-22.5T288 768h64q13 0 22.5 9.5T384 800m0-256v64q0 13-9.5 22.5T352 640h-64q-13 0-22.5-9.5T256 608v-64q0-13 9.5-22.5T288 512h64q13 0 22.5 9.5T384 544m1152 512v64q0 13-9.5 22.5t-22.5 9.5H544q-13 0-22.5-9.5T512 1120v-64q0-13 9.5-22.5t22.5-9.5h960q13 0 22.5 9.5t9.5 22.5m0-256v64q0 13-9.5 22.5T1504 896H544q-13 0-22.5-9.5T512 864v-64q0-13 9.5-22.5T544 768h960q13 0 22.5 9.5t9.5 22.5m0-256v64q0 13-9.5 22.5T1504 640H544q-13 0-22.5-9.5T512 608v-64q0-13 9.5-22.5T544 512h960q13 0 22.5 9.5t9.5 22.5m128 704V416q0-13-9.5-22.5T1632 384H160q-13 0-22.5 9.5T128 416v832q0 13 9.5 22.5t22.5 9.5h1472q13 0 22.5-9.5t9.5-22.5m128-1088v1088q0 66-47 113t-113 47H160q-66 0-113-47T0 1248V160Q0 94 47 47T160 0h1472q66 0 113 47t47 113" /></svg>
            </div>
          </a>
        </li>

        <li *ngIf="data && token" (click)="cartweb()">
          <div class="containernotifi">
            <i class="icon1 fa fa-shopping-cart" style="cursor: pointer;">
              <label class="badge">{{itemdataList}}</label>

            </i>
          </div>
          <!--<svg xmlns="http://www.w3.org/2000/svg" width="38" height="41" fill="currentColor" class="bi bi-cart" viewBox="0 0 16 16">
            <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M3.102 4l1.313 7h8.17l1.313-7zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
          </svg>-->

        </li>
        <li *ngIf="data && token">
          <div class="dropdown">
            <figure *ngIf="currentUser.profileImage != null; else pics">
              <img src="{{currentUser.profileImage}}" class="dp_wrap blank-pic-mob">
            </figure>
            <ng-template #pics>
              <figure class="amenity-icon-wrap amenity-img">
                <img src="assets/Images/default_pic.png" class="dp_wrap blank-pic-mob">
              </figure>
            </ng-template>

            <div class="dropdown-content">
              <button ngbDropdownItem (click)="openModal2()"><i class="icon-password mr-3"></i>Change Password</button>
              <button ngbDropdownItem (click)="openModal3()"><i class="icon-my-profile mr-3"></i>Profile</button>

            </div>
          </div>
        </li>
      </ul>
      <ul>
        <li *ngIf="data">
          <button class="btn btn-danger" (click)="logout()">Log Out</button>
        </li>
      </ul>
    </div>
  </nav>
</header>
